import React, { memo } from 'react'

export const BigBox = memo(() => (
	<svg width="178" height="114" viewBox="0 0 178 114" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M80.3439 28.7473L15.9601 16.7002L15.6191 96.3702L80.3439 113.986V28.7473Z"
			fill="#FAFBFF"
		/>
		<path
			d="M104.609 0.789062L15.6191 16.7003L80.969 30.9068L164.276 10.4495L104.609 0.789062Z"
			fill="#FAFBFF"
		/>
		<path d="M80.3428 31.0203L164.502 10.563V86.7097L80.3428 113.986V31.0203Z" fill="#D9DAF3" />
		<path d="M74.3774 53.1821L63.069 60.5695L57.7842 50.3408L74.3774 53.1821Z" fill="#C6C8E5" />
		<path d="M163.593 20.2231L105.631 33.8614L177.232 20.7914L163.593 20.2231Z" fill="#FAFBFF" />
		<path d="M13.9712 68.2407L71.3654 84.152L0.333008 68.2407H13.9712Z" fill="#EBEFFF" />
		<path
			d="M16.2441 16.9849L80.4574 31.1345"
			stroke="white"
			strokeWidth="0.568259"
			strokeMiterlimit="10"
		/>
		<path
			opacity="0.95"
			d="M70.7402 16.7003C87.5606 17.1549 136.999 12.7225 151.774 8.17643L104.608 0.789062L15.96 16.7003L16.1873 62.7293L30.962 20.1099C36.4741 19.9394 53.9197 16.2457 70.7402 16.7003Z"
			fill="#C6C8E5"
		/>
		<path
			opacity="0.95"
			d="M57.4418 20.6781C83.5818 16.7003 136.998 12.7225 151.773 8.17643L104.607 0.789062L15.3906 16.7003L30.7336 20.1099C36.2457 19.9394 40.7918 23.2353 57.4418 20.6781Z"
			fill="#FAFBFF"
		/>
	</svg>
))

export const SmallBig = memo(() => (
	<svg width="122" height="91" viewBox="0 0 122 91" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M57.6368 22.6375L5.81152 12.5225V76.1675L57.6368 90.0899V22.6375Z" fill="#FAFBFF" />
		<path
			d="M71.8439 0.588867L5.92578 12.5223L57.6374 22.751L121.851 6.83972L71.8439 0.588867Z"
			fill="#FAFBFF"
		/>
		<path
			d="M57.6363 22.7512L121.85 6.49902V63.9501L57.4658 89.8627L57.6363 22.7512Z"
			fill="#D9DAF3"
		/>
		<path d="M113.781 45.2544L107.7 54.0624L100.768 48.1525L113.781 45.2544Z" fill="#FAFBFF" />
		<path d="M54.6251 49.6294L100.143 37.1846L45.3057 55.1416L54.6251 49.6294Z" fill="#FAFBFF" />
		<path d="M5.86851 59.5176L32.8608 66.6208L0.0722656 60.7678L5.86851 59.5176Z" fill="#FAFBFF" />
	</svg>
))
export const BoxShadow = memo(() => (
	<svg width="200" height="51" viewBox="0 0 200 51" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			opacity="0.95"
			d="M138.881 50.9423L182.637 49.8058L199.173 25.9389L66.7688 0.367188L0.225586 18.5515L20.7397 25.9389L71.8263 40.7136L99.671 40.1454L138.881 50.9423Z"
			fill="#EBEFFF"
		/>
	</svg>
))
export const TicketLoginIcon = memo(() => (
	<svg width="178" height="175" viewBox="0 0 178 175" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M26.99 7.21198C27.7855 9.25771 30.1722 11.2466 32.3316 11.0193C34.5478 10.792 35.1729 8.3485 34.4342 6.24594C36.5935 6.01863 37.6732 5.84816 39.7758 5.62085C40.6282 7.78024 43.0149 9.25771 45.2311 8.97358C47.4473 8.63263 48.6406 6.8142 47.7882 4.65481C49.9476 4.42751 51.0273 4.25703 53.1299 4.02972C53.9255 6.07546 56.2553 7.49611 58.4147 7.21198C60.6309 6.87102 61.8243 5.10942 61.1423 3.12051C63.3017 2.89321 64.3814 2.72273 66.484 2.49542C67.2796 4.48433 69.5526 5.84816 71.7688 5.56403C73.985 5.2799 75.2352 3.51829 74.5533 1.52939C76.7127 1.30208 77.7923 1.1316 79.8949 0.904297C80.6336 2.6659 82.5657 3.9729 84.4978 4.02972C96.3744 12.7809 107.058 22.214 117.116 33.011C115.695 53.1842 111.32 72.7891 107.285 92.5077C103.25 113.704 100.523 134.275 103.478 155.755C104.33 160.642 101.375 164.961 96.204 165.586C89.5553 166.381 82.9067 167.177 76.1444 167.916C73.8714 158.199 70.064 150.754 58.1306 150.754C47.9019 151.323 39.378 156.437 36.8777 172.519C30.3427 173.314 23.7509 174.053 17.1591 174.848C12.1584 175.417 7.21453 171.894 6.53262 166.95C2.1002 116.147 30.5132 66.1405 18.7502 16.6451C17.5569 12.099 20.114 8.00754 25.1715 7.43928C25.8534 7.32563 26.2512 7.26881 26.99 7.21198ZM88.7029 121.205C86.5435 121.489 85.0661 119.955 85.3502 117.682C85.6912 115.465 87.6801 113.42 89.8394 113.079C91.9988 112.795 93.4195 114.329 93.1354 116.602C92.7944 118.818 90.8623 120.864 88.7029 121.205ZM72.2234 119.102C71.9393 121.318 73.4736 122.966 75.6898 122.739C77.906 122.512 79.9517 120.58 80.2359 118.307C80.5768 116.09 79.0425 114.443 76.8263 114.67C74.6101 114.954 72.5075 116.943 72.2234 119.102ZM62.2789 124.046C60.0627 124.273 58.5284 122.625 58.8125 120.409C59.0966 118.193 61.256 116.147 63.4154 115.977C65.6316 115.75 67.1091 117.454 66.8249 119.614C66.5408 121.887 64.4951 123.876 62.2789 124.046ZM45.6289 122.114C45.3447 124.33 46.8222 125.865 49.0384 125.58C51.2546 125.239 53.2435 123.251 53.5277 120.978C53.8118 118.761 52.3912 117.17 50.1749 117.454C47.9587 117.852 45.9698 119.898 45.6289 122.114ZM35.798 127.342C33.5818 127.626 32.1043 126.092 32.5021 123.876C32.8999 121.716 34.9456 119.614 37.105 119.386C39.3212 119.102 40.7418 120.637 40.3441 122.853C40.0031 125.012 38.0142 127.115 35.798 127.342ZM18.8638 125.012C18.5797 127.228 20.114 128.876 22.3302 128.706C24.6033 128.479 26.649 126.603 26.99 124.387C27.3309 122.171 25.8534 120.523 23.5804 120.693C21.3642 120.807 19.2616 122.796 18.8638 125.012Z"
			fill="#B8C2EB"
		/>
		<path
			opacity="0.42"
			d="M44.0374 25.7373C44.2647 23.9756 44.6625 22.4982 45.6854 22.6687C47.106 22.896 47.5606 24.828 47.9016 26.5896C48.1289 27.6125 48.2994 28.4649 48.6403 28.749C48.9245 28.6922 49.0381 28.6922 49.3222 28.6354C49.7769 28.2376 50.4019 27.2716 50.9702 26.3055C51.8226 24.8849 52.7318 23.4642 53.3569 23.6347C53.7547 23.7483 53.982 24.6007 54.0956 25.6236C54.2093 26.4192 54.0388 27.1579 53.7547 27.8398C68.8704 25.1122 83.9292 24.4303 99.2154 22.6687C103.875 22.1004 107.967 25.2826 108.08 29.8855C107.682 50.0588 103.818 68.4704 99.7837 88.189C98.8176 92.9623 94.3284 97.3948 89.7823 98.0767C70.5183 100.52 51.5385 103.589 32.1608 105.123C27.2738 105.35 24.0915 101.714 25.0576 96.997C29.2627 77.5057 32.5018 58.2417 32.5586 38.1253C32.4449 33.5792 36.025 29.6582 40.9688 29.4309C42.6168 29.3741 43.4123 29.3173 45.0603 29.2036C44.3784 28.2376 43.9238 27.0442 44.0374 25.7373Z"
			fill="white"
		/>
		<path
			d="M40.3446 122.966C40.0037 125.126 38.0148 127.115 35.9122 127.456C33.7528 127.797 32.2754 126.205 32.6163 124.046C33.0141 121.887 35.0598 119.898 37.1624 119.614C39.2649 119.329 40.6856 120.807 40.3446 122.966Z"
			fill="white"
		/>
		<path
			d="M53.6972 121.148C53.4131 123.364 51.3673 125.353 49.2648 125.694C47.1054 125.978 45.6279 124.444 45.9688 122.228C46.253 120.012 48.3555 118.023 50.4581 117.739C52.5607 117.454 53.9813 118.932 53.6972 121.148Z"
			fill="white"
		/>
		<path
			d="M66.6544 119.841C66.3703 122.057 64.3246 123.989 62.1652 124.217C59.949 124.444 58.4715 122.796 58.7556 120.58C59.0398 118.363 61.1423 116.431 63.3585 116.204C65.4043 115.977 66.9386 117.625 66.6544 119.841Z"
			fill="white"
		/>
		<path
			d="M80.1222 118.534C79.8381 120.75 77.7923 122.683 75.633 122.91C73.4167 123.137 71.9393 121.489 72.2234 119.33C72.5644 117.114 74.6101 115.182 76.8263 114.954C78.9857 114.727 80.4632 116.318 80.1222 118.534Z"
			fill="white"
		/>
		<path
			d="M93.1919 116.716C92.9078 118.932 90.9189 120.921 88.8732 121.205C86.7138 121.546 85.2363 119.955 85.5772 117.739C85.8614 115.523 87.9071 113.534 89.9529 113.25C92.0554 112.966 93.5329 114.5 93.1919 116.716Z"
			fill="white"
		/>
		<path
			d="M26.8187 124.501C26.4777 126.66 24.432 128.535 22.2158 128.763C19.9996 128.99 18.4653 127.342 18.8062 125.126C19.0904 122.909 21.2497 121.034 23.466 120.864C25.6822 120.693 27.2165 122.341 26.8187 124.501Z"
			fill="white"
		/>
		<path
			d="M78.8146 113.306C84.7245 125.012 89.3223 129.286 102.847 132.128C102.847 132.128 102.847 126.275 101.767 123.604C97.7894 113.83 76.0301 107.68 78.8146 113.306Z"
			fill="#B8C2EB"
		/>
		<path
			d="M48.3 68.6425C51.059 68.5167 53.247 67.3473 53.187 66.0305C53.1269 64.7136 50.8416 63.7481 48.0826 63.8739C45.3236 63.9996 43.1356 65.169 43.1956 66.4859C43.2556 67.8027 45.5409 68.7682 48.3 68.6425Z"
			fill="#B8C2EB"
		/>
		<path
			d="M89.4933 61.3754C92.2524 61.2496 94.4403 60.0802 94.3803 58.7634C94.3203 57.4466 92.035 56.481 89.276 56.6068C86.5169 56.7325 84.3289 57.902 84.389 59.2188C84.449 60.5356 86.7343 61.5011 89.4933 61.3754Z"
			fill="#B8C2EB"
		/>
		<path
			d="M48.9817 55.9689C48.7543 55.8553 48.5839 55.5712 48.527 55.3438C48.4134 54.8892 48.7543 54.4915 49.1521 54.4915C49.5499 54.4915 50.0045 54.7756 50.1182 55.2302C50.6296 55.7985 51.3683 56.2531 52.1071 56.4804C53.0731 56.8781 53.9823 56.935 54.5506 56.935C55.7439 56.935 57.4487 56.6508 58.3011 55.0029C58.2443 54.6051 58.5284 54.2642 58.9262 54.2642C59.3808 54.2642 59.7786 54.6051 59.8922 55.1165C59.9491 55.4007 59.8922 55.628 59.6649 55.7985C58.5284 58.0715 56.1417 58.4125 54.7211 58.4693C53.9823 58.5261 52.8458 58.3556 51.6525 57.901C50.8001 57.5032 49.7204 56.8782 48.9817 55.9689Z"
			fill="#413321"
		/>
		<path
			d="M78.9289 52.7868C78.7016 52.6732 78.5311 52.389 78.4743 52.1617C78.3607 51.7071 78.7016 51.3093 79.0994 51.3093C79.4972 51.3093 79.9518 51.5935 80.0654 52.0481C80.5769 52.6163 81.3156 53.0709 82.0544 53.2982C83.0204 53.696 83.9296 53.7528 84.4979 53.7528C85.6912 53.7528 87.396 53.4687 88.2484 51.8208C88.1916 51.423 88.4757 51.082 88.8735 51.082C89.3281 51.082 89.7258 51.423 89.8395 51.9344C89.8963 52.2186 89.8395 52.4459 89.6122 52.6163C88.4757 54.8894 86.089 55.2303 84.6683 55.2871C83.9296 55.344 82.7931 55.1735 81.5997 54.7189C80.7473 54.3211 79.6677 53.7529 78.9289 52.7868Z"
			fill="#413321"
		/>
		<path
			d="M81.8344 71.5632C83.662 76.8081 75.86 84.8635 67.4439 85.4688C59.0278 86.0742 50.62 79.5192 51.411 73.7868C51.411 73.7868 61.5111 75.4699 67.5396 74.9565C73.568 74.443 81.8344 71.5632 81.8344 71.5632Z"
			fill="black"
		/>
		<path
			d="M53.4678 74.1821V74.3526C53.5246 74.9209 53.9792 75.4323 54.5475 75.4891C56.8773 75.7164 62.6736 76.6825 66.6514 76.3983C72.7615 75.9619 76.3118 74.1253 78.5848 73.557C79.1531 73.3866 79.5509 72.8751 79.4941 72.25V72.0796C77.6756 72.3069 71.0554 74.9493 66.6514 74.9493C58.1275 74.9493 55.343 74.1253 53.4678 74.1821Z"
			fill="white"
		/>
		<path
			d="M79.7822 71.653C80.0664 71.5962 80.2937 71.5962 80.2937 71.5962L79.7822 71.653Z"
			fill="black"
			fillOpacity="0.23"
		/>
		<path
			d="M86.0194 89.4711C82.2689 114.986 100.453 136.239 125.116 136.864C148.244 137.489 168.644 119.532 171.997 96.9153C175.35 74.2418 163.644 54.6368 137.901 50.4885C111.477 46.1129 89.7699 63.9563 86.0194 89.4711Z"
			fill="#2FCA7D"
		/>
		<path
			d="M91.4745 91.8579C87.724 117.373 105.908 138.626 130.571 139.251C153.699 139.876 174.099 121.919 177.452 99.3021C180.805 76.6286 166.144 55.7166 143.413 52.3071C119.206 48.727 95.225 66.3431 91.4745 91.8579Z"
			fill="#4BE397"
		/>
		<path
			d="M126.253 77.8221C125.287 84.3571 129.776 90.1533 136.141 90.7216C142.392 91.3467 148.188 86.6301 149.097 80.3224C150.006 74.0147 145.801 68.2753 139.607 67.4229C133.243 66.6274 127.219 71.2871 126.253 77.8221Z"
			fill="white"
		/>
		<path
			d="M135.288 97.256C146.938 98.222 154.723 108.451 153.075 120.1L109.773 117.77C111.762 105.439 123.298 96.29 135.288 97.256Z"
			fill="white"
		/>
		<path
			d="M149.097 53.5572C147.278 52.989 145.346 52.5912 143.414 52.3071C119.206 48.727 95.2257 66.3431 91.4752 91.8579C88.4066 112.599 99.8287 130.5 117.445 136.807L123.468 138.455"
			stroke="#FFA39C"
			strokeWidth="0.568259"
			strokeMiterlimit="10"
		/>
		<path
			d="M162.629 77.3349L170.812 73.7549"
			stroke="#909ED5"
			strokeWidth="9.09215"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M117.173 33.0108C111.149 34.2041 105.694 35.3406 99.6705 36.4771C92.3968 37.8978 85.9755 32.613 85.464 25.3393C84.5548 16.8154 82.3954 9.08705 79.7246 0.960938C87.7371 6.52988 96.1473 12.3261 103.478 18.9179C108.479 23.3504 112.627 28.0101 117.173 33.0108Z"
			fill="#909ED5"
		/>
		<path
			d="M82.7922 117.284C52.1062 136.605 18.6874 129.343 13.6299 115.648"
			stroke="#B8C2EB"
			strokeWidth="9.09215"
			strokeMiterlimit="10"
		/>
		<path
			d="M95.578 101.657C58.9252 135.127 11.9251 124.741 6.24247 109.398C0.446219 101.442 11.3568 85.5309 20.449 83.2578"
			stroke="#909ED5"
			strokeWidth="9.09215"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
))

// export const UserIcon = memo(() => (
// 	<svg width="87" height="84" viewBox="0 0 87 84" fill="none" xmlns="http://www.w3.org/2000/svg">
// 		<path
// 			d="M86.0738 43.7098C86.0738 67.7212 66.3803 84.8345 43.6327 82.0438C22.2541 79.4636 5.87793 60.1913 5.87793 38.8654C5.87793 17.5395 19.358 1.11069 43.6327 0.742092C68.5392 0.32084 86.0738 19.6984 86.0738 43.7098Z"
// 			fill="#C6C1B5"
// 		/>
// 		<path
// 			d="M80.7555 45.1849C80.7555 69.1963 61.0619 86.3096 38.3143 83.5188C16.9357 80.9387 0.55957 61.6664 0.55957 40.3405C0.55957 19.0146 16.9357 1.74327 38.3143 1.74327C61.0619 1.69061 80.7555 21.1735 80.7555 45.1849Z"
// 			fill="#E4E0D4"
// 		/>
// 		<path
// 			d="M50.7418 27.333C50.7418 33.4938 45.8448 38.1803 39.8946 37.8643C34.0497 37.5484 29.3633 32.4407 29.3633 26.5432C29.3633 20.6457 34.0497 15.8539 39.8946 15.9592C45.7921 16.1172 50.7418 21.2249 50.7418 27.333Z"
// 			fill="white"
// 		/>
// 		<path
// 			d="M39.7358 44.0785C28.8886 43.3939 20.3056 51.7136 20.2529 62.6662L60.4298 66.4048C60.3245 54.7677 50.899 44.763 39.7358 44.0785Z"
// 			fill="white"
// 		/>
// 		<path
// 			d="M32.8389 2.05854C34.5765 1.79525 36.4195 1.68994 38.2625 1.68994C61.0628 1.68994 80.7036 21.1728 80.7036 45.1842C80.7036 64.6671 67.7501 79.6216 50.6368 83.0443"
// 			stroke="#F2F0EB"
// 			strokeWidth="0.568259"
// 			strokeMiterlimit="10"
// 		/>
// 	</svg>
// ))

export const UserIcon = memo(() => (
	<svg width="93" height="90" viewBox="0 0 93 90" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M92.343 46.7039C92.343 72.6165 71.0901 91.0849 46.5413 88.0732C23.47 85.2887 5.79712 64.4904 5.79712 41.4759C5.79712 18.4614 20.2877 0.674848 46.4845 0.277067C73.3632 -0.120715 92.343 20.7912 92.343 46.7039Z"
			fill="#D9DAF3"
		/>
		<path
			d="M86.5464 48.2388C86.5464 74.1514 65.2935 92.6199 40.7447 89.6081C17.6734 86.8236 0.000488281 66.0253 0.000488281 43.0108C0.000488281 19.9963 17.6734 1.35742 40.7447 1.35742C65.2935 1.35742 86.5464 22.383 86.5464 48.2388Z"
			fill="#F3F6FF"
		/>
		<path
			d="M54.1563 29.0304C54.1563 35.679 48.8715 40.7365 42.4501 40.3955C36.1425 40.0546 31.085 34.5425 31.085 28.1211C31.085 21.6998 36.1425 16.5855 42.4501 16.6991C48.8715 16.8696 54.1563 22.3817 54.1563 29.0304Z"
			fill="#DAE0FA"
		/>
		<path
			d="M42.2789 47.0445C30.5728 46.3057 21.3101 55.2842 21.2533 67.104L64.6115 71.1387C64.4978 58.6369 54.3828 47.84 42.2789 47.0445Z"
			fill="#DAE0FA"
		/>
	</svg>
))

export const BookIcon = memo(({ rotate = '0', scale = '1' }) => {
	let style = {
		transform: `rotate(${rotate}deg) scale(${scale})`
	}
	return (
		<svg
			style={style}
			width="126"
			height="145"
			viewBox="0 0 126 145"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="40.3174"
				y="0.781494"
				width="89.5926"
				height="119.877"
				rx="8.83307"
				transform="rotate(18.0468 40.3174 0.781494)"
				fill="#DBE1F9"
			/>
			<rect
				x="37.1367"
				y="2.39917"
				width="89.5926"
				height="119.877"
				rx="8.83307"
				transform="rotate(18.0468 37.1367 2.39917)"
				fill="#DBE1F9"
			/>
			<rect
				x="24.0342"
				y="71.124"
				width="73.1883"
				height="7.57121"
				transform="rotate(18.0468 24.0342 71.124)"
				fill="white"
			/>
			<rect
				x="30.5596"
				y="91.8303"
				width="46.6891"
				height="7.57121"
				transform="rotate(18.0468 30.5596 91.8303)"
				fill="white"
			/>
			<circle
				cx="70.152"
				cy="45.6717"
				r="20.8208"
				transform="rotate(18.0468 70.152 45.6717)"
				fill="white"
			/>
			<circle
				cx="73.2924"
				cy="38.0688"
				r="6.30934"
				transform="rotate(18.0468 73.2924 38.0688)"
				fill="#123BED"
			/>
			<path
				d="M70.9471 45.2671C64.3209 43.1081 57.199 46.7295 55.04 53.3558L79.0358 61.1742C81.1948 54.5479 77.5733 47.4261 70.9471 45.2671Z"
				fill="#123BED"
			/>
		</svg>
	)
})

export const UserIconSignIn = memo(() => (
	<svg width="206" height="187" viewBox="0 0 206 187" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M104.375 83.3834C104.375 83.3834 128.365 95.7295 139.757 96.4823C173.583 98.6906 201.739 74.6006 201.739 74.6006"
			stroke="#B8C2EB"
			strokeWidth="8.02999"
			strokeMiterlimit="10"
			strokeLinecap="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.1247 22.6571C9.71942 23.4099 7.31042 22.7574 5.45348 21.2518C5.22772 21.4023 5.05211 21.5152 4.87651 21.6281L4.87632 21.6282C4.70067 21.7412 4.52501 21.8541 4.29917 22.0046C0.836239 24.0121 -1.92407 29.9342 1.89018 33.3972C41.1869 71.9913 34.2611 130.56 18.5524 178.389C16.8962 183.156 19.8071 186.87 25.6288 186.87C28.0713 186.87 30.5137 186.876 32.9562 186.882C37.8411 186.893 42.726 186.904 47.6109 186.87C53.6334 176.933 65.2267 167.749 76.6193 167.498C87.6103 167.297 89.1661 176.08 83.6455 185.716V185.766H96.0418C100.709 184.311 104.172 178.84 105.678 174.524C113.055 149.932 117.07 125.24 117.221 99.3937C116.819 77.4116 113.708 56.2325 107.786 35.1036C94.9377 22.6571 81.2867 12.0675 65.5279 3.53566C63.3196 3.48547 60.6597 2.28097 59.2042 0.524414C56.9459 0.925894 55.7916 1.17683 53.4832 1.67865L53.4831 1.67868L53.483 1.67869L53.4829 1.67873C54.9885 3.68622 54.336 5.79409 52.0274 6.39634C49.7188 7.04878 46.6574 5.89447 45.0012 3.88697C44.5289 4.01578 44.0933 4.13311 43.6748 4.24584L43.6744 4.24595L43.6744 4.24596L43.6743 4.24597L43.6742 4.246C42.1364 4.66025 40.8292 5.01236 38.7779 5.64353C40.3338 7.65103 39.4304 9.95965 37.1218 10.7627C34.8131 11.5656 31.8521 10.7125 30.1457 8.85553C28.088 9.7589 27.0843 10.2106 25.1771 11.1641C26.8333 12.9709 26.5322 15.2293 24.5749 16.1327C22.6176 17.0863 19.6063 16.4338 17.8498 14.7776C17.3179 15.0371 16.7457 15.3134 16.155 15.5986C14.4605 16.4167 12.6132 17.3085 11.1247 18.09C12.831 19.7462 12.5801 21.9043 11.1247 22.6571ZM97.6478 132.919C97.5364 134.033 97.6327 135.018 97.919 135.752C98.2602 136.738 98.923 137.301 99.8578 137.184C101.115 137.027 102.558 135.7 103.269 133.927C103.5 133.378 103.66 132.784 103.72 132.166C104.022 129.606 102.516 127.649 100.86 127.85C99.1534 128.101 97.8988 130.409 97.6478 132.919ZM92.4495 137.681C91.9034 138.313 91.245 138.75 90.5224 138.891C88.7156 139.242 87.0594 137.636 87.2602 135.177C87.3565 134.252 87.7114 133.343 88.2145 132.55C89.0223 131.277 90.212 130.305 91.3253 130.058C93.1321 129.656 94.186 131.413 93.9853 133.872C93.8347 135.348 93.2686 136.733 92.4495 137.681ZM76.2178 140.497C73.859 140.648 72.253 138.841 72.5039 136.432C72.7047 133.973 74.662 131.865 77.071 131.714C79.4298 131.514 81.3871 133.32 81.1361 135.78C80.8852 138.189 78.5766 140.296 76.2178 140.497ZM46.4064 141.702C43.7967 141.601 42.0401 139.594 42.3412 137.235C42.6424 134.876 44.9008 133.069 47.4102 133.17C49.9697 133.27 51.9772 135.227 51.7263 137.586C51.4754 139.945 49.0162 141.802 46.4064 141.702ZM108.54 134.324C109.343 133.671 110.196 131.112 110.447 128.552C110.698 125.992 110.347 124.537 109.544 125.189C108.741 125.842 107.687 128.401 107.436 130.911C107.135 133.42 107.737 134.976 108.54 134.324Z"
			fill="#B8C2EB"
		/>
		<path
			opacity="0.42"
			d="M29.3947 33.1469C28.8426 31.3402 28.7422 29.684 30.2478 29.2825C32.4561 28.7304 33.2591 30.9387 34.4636 32.5447C35.1662 33.4982 35.8187 34.3012 36.2703 34.5522C36.5213 34.4518 36.6718 34.4016 36.9228 34.3514C37.2239 33.8495 37.3243 32.8458 37.4247 31.7918C37.5752 30.2862 37.7258 28.6802 38.4284 28.7806C38.8801 28.8308 39.5325 29.6338 40.185 30.6375C40.6868 31.3903 40.9378 32.1933 40.988 32.896C55.191 27.9274 72.1042 22.3064 87.311 22.3566C91.2256 22.0555 95.893 25.418 97.7499 30.2862C105.629 51.5657 110.096 73.1463 111.551 95.7808C111.802 101.251 110.748 106.872 108.289 108.177C91.5267 115.153 70.2472 115.504 52.4307 116.609C47.2112 116.609 43.2464 112.292 43.0456 107.224C41.791 85.8437 37.1235 66.2706 26.8351 47.4001C24.3759 43.1342 23.8239 39.2698 28.0898 37.6136C29.495 37.0615 30.298 36.7604 32.3055 35.9574C30.8501 35.4555 29.7962 34.4518 29.3947 33.1469Z"
			fill="white"
		/>
		<path
			d="M53.3107 147.6C68.8764 151.098 84.2672 141.304 87.7651 125.738C91.2631 110.172 81.4689 94.7817 65.9032 91.2837C50.3375 87.7858 34.9467 97.58 31.4488 113.146C27.9509 128.711 37.745 144.102 53.3107 147.6Z"
			fill="#FE2431"
		/>
		<path
			d="M74.123 119.617L47.1891 113.671L45.9648 118.568L72.8988 124.514L74.123 119.617Z"
			fill="white"
		/>
		<path
			d="M65.5537 104.226L61.3562 103.352L54.3604 134.658L58.5578 135.533L65.5537 104.226Z"
			fill="white"
		/>
		<path
			d="M66.885 110.665C57.9044 118.313 47.0784 128.054 34.5824 128.83C32.9964 128.929 31.3835 128.883 29.7441 128.67"
			stroke="#909ED5"
			strokeWidth="8.02999"
			strokeMiterlimit="10"
		/>
		<path
			d="M35.5173 94.1743C35.5173 94.1743 22.4185 104.764 19.2065 109.732C9.66784 124.487 20.6772 127.072 35.5173 124.789C57.1646 121.458 66.6335 111.288 66.6335 111.288"
			stroke="#B8C2EB"
			strokeWidth="8.02999"
			strokeMiterlimit="10"
			strokeLinecap="round"
		/>
		<path
			d="M107.435 35.0027L92.429 32.5937C83.7968 31.7406 77.8747 25.8686 73.9099 20.0469L59.6064 1.12622C59.6064 1.12622 76.9211 7.04834 87.7616 15.4798C98.301 23.7106 107.435 35.0027 107.435 35.0027Z"
			fill="#909ED5"
		/>
		<path
			d="M53.3199 71.6099C56.3001 70.7408 58.3763 68.8714 57.9572 67.4345C57.5382 65.9977 54.7826 65.5374 51.8024 66.4065C48.8222 67.2757 46.746 69.145 47.165 70.5819C47.584 72.0188 50.3397 72.4791 53.3199 71.6099Z"
			fill="#B8C2EB"
		/>
		<path
			d="M95.3384 59.3765C98.3186 58.5074 100.395 56.638 99.9758 55.2011C99.5568 53.7643 96.8011 53.304 93.8209 54.1731C90.8407 55.0423 88.7645 56.9116 89.1836 58.3485C89.6026 59.7854 92.3582 60.2457 95.3384 59.3765Z"
			fill="#B8C2EB"
		/>
		<path
			d="M51.5463 59.6078C51.4047 59.8149 51.3633 60.0177 51.4745 60.264C51.5923 60.6607 52.0524 60.8416 52.399 60.726C52.7455 60.6103 52.9809 60.2484 52.8631 59.8517C53.0374 59.2412 53.4645 58.67 53.9964 58.1946C54.6241 57.6146 55.411 57.2286 55.9058 57.0563C56.9456 56.7094 58.5391 56.3886 60.037 57.3279C60.2027 57.6723 60.5603 57.8074 60.957 57.6896C61.3537 57.5718 61.5346 57.1118 61.419 56.7652C61.3579 56.5167 61.1507 56.375 60.9458 56.2835C58.8745 54.8669 56.6859 55.3644 55.4979 55.768C54.8548 55.997 53.9219 56.4899 53.1481 57.1768C52.4725 57.8091 51.8056 58.642 51.5463 59.6078Z"
			fill="#123BED"
		/>
		<path
			d="M79.5378 51.7536C79.394 51.9106 79.3548 52.1634 79.4159 52.4119C79.5337 52.8087 79.9457 53.0419 80.3425 52.9241C80.6891 52.8084 80.9244 52.4465 80.859 52.0977C81.0834 51.4851 81.5629 50.9618 82.147 50.5344C82.8271 50.0023 83.6161 49.6664 84.1132 49.5443C85.1551 49.2476 86.8032 49.0248 88.2073 50.1189C88.3731 50.4633 88.7328 50.6485 89.0794 50.5329C89.4761 50.4151 89.7093 50.0031 89.5915 49.6063C89.5304 49.3578 89.3712 49.1638 89.1184 49.1246C87.1909 47.5511 84.9456 47.9004 83.7532 48.2036C83.0578 48.3847 82.1227 48.8275 81.2944 49.4162C80.5686 50.0508 79.8973 50.7834 79.5378 51.7536Z"
			fill="#123BED"
		/>
		<path
			d="M51.3431 48.0121C49.5753 48.9433 48.2895 50.5568 47.9127 52.2813C47.9149 52.3314 47.9171 52.3815 47.9193 52.4317C47.8801 52.6846 47.5858 52.8481 47.2806 52.761C46.9776 52.724 46.7159 52.4842 46.7551 52.2314C46.8009 52.1289 46.7987 52.0787 46.8466 52.0264C47.3083 49.9466 48.8863 48.1194 50.848 47.029C52.86 45.9364 55.4105 45.6743 57.7237 46.8793C57.7739 46.8771 57.8262 46.9251 57.8785 46.973C58.0355 47.1169 58.1446 47.3131 58.1032 47.5158C58.0662 47.8188 57.724 48.0347 57.421 47.9977C57.2683 47.9542 57.1157 47.9106 57.059 47.7624C55.1601 46.8406 53.0608 47.083 51.3431 48.0121Z"
			fill="#909ED5"
		/>
		<path
			d="M83.8219 39.4598C85.7861 39.5749 87.6829 40.4465 88.7492 41.8568C88.7514 41.9069 88.8037 41.9549 88.8561 42.0028C89.0153 42.1968 89.3183 42.2338 89.6104 42.0201C89.9046 41.8565 89.9896 41.5012 89.8304 41.3072C89.7781 41.2592 89.6734 41.1633 89.6211 41.1154C88.341 39.4131 86.1369 38.4042 83.8718 38.3022C81.5566 38.2024 79.1304 39.0117 77.5635 41.0896C77.5657 41.1397 77.5177 41.192 77.5199 41.2422C77.4284 41.4471 77.4371 41.6477 77.5462 41.8439C77.7076 42.088 78.0629 42.1729 78.3572 42.0094C78.5032 41.9025 78.549 41.8 78.5925 41.6474C79.8784 40.034 81.8577 39.3447 83.8219 39.4598Z"
			fill="#909ED5"
		/>
		<path
			d="M91.8194 67.2417C95.1646 72.521 88.5506 83.2589 79.478 86.0163C70.4054 88.7738 59.5828 83.6705 58.9993 77.2156L74.666 72.4621L91.8194 67.2417Z"
			fill="black"
		/>
		<path
			d="M62.2997 76.8708L89.1208 68.7163L89.5893 67.9423L61.4778 76.4546L62.2997 76.8708Z"
			fill="#939292"
		/>
		<path
			d="M61.5806 76.5003L61.6395 76.6987C61.8184 77.3439 62.4398 77.7689 63.1373 77.6379C65.7358 77.3235 72.2255 76.3869 76.5394 75.0932C80.8534 73.7996 86.7061 70.9317 89.0668 69.7736C89.6575 69.4966 89.9277 68.7815 89.7488 68.1363L89.6899 67.9379C87.7629 68.6751 80.6915 71.2447 75.7825 72.715C70.8734 74.1854 63.5686 76.0116 61.5806 76.5003Z"
			fill="white"
		/>
		<path
			d="M89.6409 67.9403C89.9875 67.8247 90.1358 67.768 90.1358 67.768L90.1336 67.7178L89.5886 67.8924L89.6409 67.9403Z"
			fill="black"
			fillOpacity="0.23"
		/>
	</svg>
))

export const BigBook = memo(() => (
	<svg width="184" height="247" viewBox="0 0 184 247" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M182.691 236.478V236.227C182.691 235.826 182.942 235.474 183.293 235.274C183.895 234.922 183.443 233.166 172.151 224.785C160.156 215.851 146.004 203.957 140.232 198.988C135.511 194.924 135.21 199.396 135.511 200.399L138.024 203.204C138.074 203.304 137.472 207.119 137.522 207.219L163.72 240.242C163.971 240.594 164.372 240.794 164.774 240.694L181.787 237.482C182.339 237.432 182.691 236.98 182.691 236.478Z"
			fill="#0C2696"
		/>
		<path
			d="M122.915 244.702L16.2664 211.574C9.99297 209.649 5.02441 201.747 5.02441 193.946V15.3374C5.02441 7.53662 9.99297 1.20477 16.2664 1.25543L122.915 1.55936C131.447 1.55936 138.523 9.15757 138.523 18.5287V232.646C138.523 241.967 131.447 247.387 122.915 244.702Z"
			fill="#909ED5"
		/>
		<path
			d="M117.897 241.302L11.2488 208.429C4.97539 206.522 0.00683594 198.693 0.00683594 190.964V14.0532C0.00683594 6.32432 4.97539 0.101074 11.2488 0.101074L117.897 0.402199C126.429 0.402199 133.505 7.93031 133.505 17.215V229.357C133.505 238.592 126.429 243.912 117.897 241.302Z"
			fill="#DBE1F9"
		/>
		<path d="M111.572 135.657L16.0654 118.894V104.089L111.572 118.794V135.657Z" fill="#909ED5" />
		<path d="M60.7322 150.362L16.0654 141.077V126.272L60.7322 134.603V150.362Z" fill="#909ED5" />
		<path
			d="M98.6749 178.417C82.1633 185.293 70.1685 195.682 60.7332 195.631C51.4987 195.581 47.7849 187.802 32.5781 188.053C17.9735 188.304 13.5068 209.031 13.5068 209.031L16.0664 209.985L117.947 241.352C126.479 243.962 133.555 238.642 133.555 229.357V174.352C133.505 174.352 117.395 170.638 98.6749 178.417Z"
			fill="#72F4B3"
		/>
		<path
			d="M58.1727 53.7016C58.1727 68.0552 48.2858 78.5945 36.4917 77.2896C25.049 76.035 16.0654 64.0402 16.0654 50.5397C16.0654 37.0393 25.049 26.3996 36.4917 26.8513C48.3359 27.303 58.1727 39.3479 58.1727 53.7016Z"
			fill="white"
		/>
		<path d="M118.901 229.909L83.9199 219.671V211.541L118.901 221.427V229.909Z" fill="white" />
		<path
			d="M42.0631 42.5092C42.0631 46.2733 39.5035 49.1842 36.3417 48.9332C33.2301 48.7325 30.7207 45.5205 30.7207 41.8066C30.7207 38.0928 33.2301 35.2321 36.3417 35.3826C39.5035 35.5332 42.0631 38.7452 42.0631 42.5092Z"
			fill="#123BED"
		/>
		<path
			d="M36.3418 52.3462C30.1688 51.8945 25.2002 57.4653 25.2002 64.8429L47.8347 67.0009C47.8347 59.3724 42.6654 52.7979 36.3418 52.3462Z"
			fill="#123BED"
		/>
		<rect
			x="53.2285"
			y="8.78027"
			width="27.1012"
			height="4.44997"
			rx="2.22498"
			transform="rotate(0.601959 53.2285 8.78027)"
			fill="white"
		/>
		<path
			d="M69.0639 13.3002C69.0639 13.3002 69.8167 27.3527 79.4527 36.8883C89.0887 46.4239 95.2116 111.166 109.063 151.818C122.915 192.469 142.488 239.646 159.401 244.664C176.314 249.683 181.885 242.807 181.885 242.807L183.893 235.028C183.893 235.028 173.353 238.291 159.401 229.759C145.499 217.714 136.717 203.26 120.155 145.895C103.643 88.5814 94.3082 42.4089 91.7988 36.8883C86.6797 25.5961 83.7688 17.8171 79.4025 13.3002C76.592 10.4395 66.7051 13.3002 66.7051 13.3002H69.0639Z"
			fill="#0C2696"
		/>
		<path
			d="M76.4425 35.3827C86.0785 44.9183 95.564 103.537 107.057 150.312C117.195 191.572 139.478 238.14 156.391 243.159C175.613 250.335 182.388 243.159 182.388 243.159L183.693 235.781C183.693 235.781 171.146 239.144 162.112 234.125C144.898 224.589 133.706 201.754 117.195 144.39C100.683 87.0757 94.51 42.4089 87.9856 31.8695C81.4613 21.3302 79.3032 13.3002 76.4425 11.7946C73.632 10.3391 63.7451 11.7946 63.7451 11.7946C63.7451 11.7946 66.8065 25.8471 76.4425 35.3827Z"
			fill="#123BED"
		/>
		<path
			d="M76.291 35.3828L83.9195 54.6045L94.5592 52.0952L96.8679 54.454L91.8491 36.8884L87.8341 31.8696L76.291 35.3828Z"
			fill="#909ED5"
		/>
		<path
			d="M85.4248 32.3715L89.4398 46.424L90.8451 45.9221L86.8803 31.8696L85.4248 32.3715Z"
			fill="#E4E0D4"
		/>
	</svg>
))
export const ShadowSignIn = memo(() => (
	<svg width="369" height="55" viewBox="0 0 369 55" fill="none" xmlns="http://www.w3.org/2000/svg">
		<ellipse cx="89.9108" cy="32.8997" rx="89.9108" ry="16.0654" fill="#EBEFFF" />
		<path
			d="M368.907 49.1687C369.174 62.6816 312.195 43.4337 234.665 49.1687C166.682 50.5139 111.354 40.65 111.087 27.137C110.819 13.6241 165.714 1.57917 233.697 0.233956C301.68 -1.11126 368.64 35.6557 368.907 49.1687Z"
			fill="#EBEFFF"
		/>
	</svg>
))
